import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { ScheduleDetailView } from '../models/schedule-detail-view.model';
import { GetScheduleDetail_schedule } from '../queries/generated/GetScheduleDetail';
import * as ScheduleDetailActions from './schedule-detail.actions';

export const scheduleDetailFeatureKey = 'scheduleDetail';

export interface State {
   schedule: ScheduleDetailView | null;
   callState: CallState;
   currentScheduleId: number | null;
}

export const initialState: State = {
   callState: LoadingState.Init,
   currentScheduleId: null,
   schedule: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(ScheduleDetailActions.scheduleDetailLoad, ScheduleDetailActions.scheduleDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         schedule: null,
      };
   }),
   on(ScheduleDetailActions.updateScheduleId, (state, { scheduleId }) => {
      return {
         ...state,
         currentScheduleId: scheduleId,
         callState: LoadingState.Loading,
      };
   }),
   on(ScheduleDetailActions.loadScheduleDetailSuccess, (state, action) => {
      const schedule: GetScheduleDetail_schedule = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         schedule: {
            ...schedule,
         },
      };
   }),
   on(ScheduleDetailActions.loadPageNoSchedule, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(ScheduleDetailActions.loadScheduleDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(ScheduleDetailActions.saveScheduleDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(ScheduleDetailActions.saveScheduleDetailFailure, ScheduleDetailActions.scheduleDetailAccessDenied, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
